import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Badge, { BadgeProps } from '@mui/material/Badge';

export const CustomBadge = styled(Badge)<BadgeProps>(() => ({
    '& .MuiBadge-badge': {
        background: 'transparent',
        right: 8,
        top: 8,
    },
}));

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#353535',
        borderRadius: '0.25rem',
        boxShadow: '4px 2px 4px 0px rgba(0, 0, 0, 0.15)',
    },
}));
